<script>
import { useI18n } from 'vue-i18n';
import SvgLimits from '@/components/svgs/SvgLimits.vue';

export default {
  name: 'NoLimitsOverlay',
  components: {
    SvgLimits
  },
  props: {
    /*
     * Entity name to display in the overlay title
     */
    entity: {
      type: String,
      required: true
    }
  },
  setup() {
    const { t } = useI18n();

    return {
      t
    };
  }
};
</script>
<template>
  <div
    class="overlay-contents d-flex flex-column align-center gap-4"
    data-testid="unit-limiter-no-limits-overlay">
    <svg-limits />
    <div class="text--color-text-tertiary text-center">
      <h3>
        {{ t('appointment.dialogs.limitsOverviewDialog.messages.noEntityLimit', { entity }) }}
      </h3>
      <p>{{ t('appointment.dialogs.limitsOverviewDialog.messages.noSpecificLimitConfigured') }}</p>
    </div>
  </div>
</template>
